// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import {
  AnonymousIdentity,
  AnonymousIdentityT,
  verifyAnonymousIdentity,
} from "./anonymous-identity";
import {
  CertificateConfig,
  CertificateConfigT,
  verifyCertificateConfig,
} from "./certificate-config";
import { EventMonitor, EventMonitorT, verifyEventMonitor } from "./event-monitor";
import {
  EventToMessageEntry,
  EventToMessageEntryT,
  verifyEventToMessageEntry,
} from "./event-to-message-entry";
import {
  HistoryReadConfig,
  HistoryReadConfigT,
  verifyHistoryReadConfig,
} from "./history-read-config";
import { Identity, unionToIdentity, unionListToIdentity } from "./identity";
import { MessageSecurityMode } from "./message-security-mode";
import {
  MessageToMethodEntry,
  MessageToMethodEntryT,
  verifyMessageToMethodEntry,
} from "./message-to-method-entry";
import {
  NamedSubscription,
  NamedSubscriptionT,
  verifyNamedSubscription,
} from "./named-subscription";
import { NodeMonitor, NodeMonitorT, verifyNodeMonitor } from "./node-monitor";
import {
  NodeToLiftIdEntry,
  NodeToLiftIdEntryT,
  verifyNodeToLiftIdEntry,
} from "./node-to-lift-id-entry";
import { OpcUaMappings, OpcUaMappingsT, verifyOpcUaMappings } from "./opc-ua-mappings";
import { RedundancyConfig, RedundancyConfigT, verifyRedundancyConfig } from "./redundancy-config";
import { SecurityPolicy } from "./security-policy";
import { SessionConfig, SessionConfigT, verifySessionConfig } from "./session-config";
import {
  SubscriptionConfig,
  SubscriptionConfigT,
  verifySubscriptionConfig,
} from "./subscription-config";
import { UserNameIdentity, UserNameIdentityT, verifyUserNameIdentity } from "./user-name-identity";
import { X509Identity, X509IdentityT, verifyX509Identity } from "./x509-identity";

/**
 * Top-level OPC UA vendor mapping (selected by the `CDO` `vendor_content` union).
 */
export class Mapping implements flatbuffers.IUnpackableObject<MappingT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): Mapping {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsMapping(bb: flatbuffers.ByteBuffer, obj?: Mapping): Mapping {
    return (obj || new Mapping()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsMapping(bb: flatbuffers.ByteBuffer, obj?: Mapping): Mapping {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new Mapping()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  applicationName(): string | null;
  applicationName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  applicationName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  applicationUri(): string | null;
  applicationUri(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  applicationUri(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  productUri(): string | null;
  productUri(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  productUri(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  securityPolicy(): SecurityPolicy {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : SecurityPolicy.None_;
  }

  securityMode(): MessageSecurityMode {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : MessageSecurityMode.None_;
  }

  identityType(): Identity {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : Identity.NONE;
  }

  identity<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  /**
   * Application instance certificate / PKI config (for Sign/SignAndEncrypt).
   */
  certificate(obj?: CertificateConfig): CertificateConfig | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset
      ? (obj || new CertificateConfig()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * Session / secure-channel tuning.
   */
  session(obj?: SessionConfig): SessionConfig | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset
      ? (obj || new SessionConfig()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * Redundant-server failover configuration.
   */
  redundancy(obj?: RedundancyConfig): RedundancyConfig | null {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset
      ? (obj || new RedundancyConfig()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * Connection-default subscription settings.
   */
  subscription(obj?: SubscriptionConfig): SubscriptionConfig | null {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset
      ? (obj || new SubscriptionConfig()).__init(
          this.bb!.__indirect(this.bb_pos + offset),
          this.bb!,
        )
      : null;
  }

  /**
   * Named subscriptions with per-subscription settings.
   */
  namedSubscriptions(index: number, obj?: NamedSubscription): NamedSubscription | null {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset
      ? (obj || new NamedSubscription()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  namedSubscriptionsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Per-point monitor mode (subscription or poll). When empty, all mapped
   * nodes default to a single subscription using `subscription`.
   */
  monitors(index: number, obj?: NodeMonitor): NodeMonitor | null {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset
      ? (obj || new NodeMonitor()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  monitorsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  mappings(obj?: OpcUaMappings): OpcUaMappings | null {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset
      ? (obj || new OpcUaMappings()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  nodeToLiftId(index: number, obj?: NodeToLiftIdEntry): NodeToLiftIdEntry | null {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset
      ? (obj || new NodeToLiftIdEntry()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  nodeToLiftIdLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * LN2 command -> OPC UA method-call mappings.
   */
  msgToMethod(index: number, obj?: MessageToMethodEntry): MessageToMethodEntry | null {
    const offset = this.bb!.__offset(this.bb_pos, 34);
    return offset
      ? (obj || new MessageToMethodEntry()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  msgToMethodLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 34);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Event/alarm subscriptions.
   */
  eventMonitors(index: number, obj?: EventMonitor): EventMonitor | null {
    const offset = this.bb!.__offset(this.bb_pos, 36);
    return offset
      ? (obj || new EventMonitor()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  eventMonitorsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 36);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Event-type -> LN2 message mappings.
   */
  eventToMsg(index: number, obj?: EventToMessageEntry): EventToMessageEntry | null {
    const offset = this.bb!.__offset(this.bb_pos, 38);
    return offset
      ? (obj || new EventToMessageEntry()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  eventToMsgLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 38);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Historical read configurations.
   */
  historyReads(index: number, obj?: HistoryReadConfig): HistoryReadConfig | null {
    const offset = this.bb!.__offset(this.bb_pos, 40);
    return offset
      ? (obj || new HistoryReadConfig()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  historyReadsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 40);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * DEPRECATED: no longer read by `LiftCloud`.
   *
   * Retained only so the table keeps its wire layout. It once held the fixed
   * segment a controller family inserts between the site and the bank path
   * ("Location" for Kone KMP OPC UA).
   *
   * `LiftCloud` now composes each full `StringNodeId` purely from the bank's and
   * lift's own columns, in the same order as OPC DA: `Bank.vendor_location_path`,
   * `Bank.vendor_site_path`, `Bank.vendor_group_path`, `Lift.vendor_lift_path`,
   * then the leaf held in `mappings`, joined with dots (for example
   * `Dulles.Terminal_E.2033.2033.AdvancePosition`).
   *
   * All three bank segments must be non-empty or composition is skipped. A bank
   * whose vendor tree has a literal tier (Kone KMP:
   * `MoffittSperos.Location.Group0.SE1`) types that literal into the matching bank
   * column. `LiftCloud` derives `Cdo.bank_binding` from the same components so the
   * node-to-lift map cannot disagree with the mappings. Unlike OPC DA there is no
   * `Absolute`/`Leaf` discriminator: OPC UA node ids are leaf-only unconditionally.
   */
  vendorPathLiteral(): string | null;
  vendorPathLiteral(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  vendorPathLiteral(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 42);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startMapping(builder: flatbuffers.Builder) {
    builder.startObject(20);
  }

  static addApplicationName(
    builder: flatbuffers.Builder,
    applicationNameOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(0, applicationNameOffset, 0);
  }

  static addApplicationUri(builder: flatbuffers.Builder, applicationUriOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, applicationUriOffset, 0);
  }

  static addProductUri(builder: flatbuffers.Builder, productUriOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, productUriOffset, 0);
  }

  static addSecurityPolicy(builder: flatbuffers.Builder, securityPolicy: SecurityPolicy) {
    builder.addFieldInt8(3, securityPolicy, SecurityPolicy.None_);
  }

  static addSecurityMode(builder: flatbuffers.Builder, securityMode: MessageSecurityMode) {
    builder.addFieldInt8(4, securityMode, MessageSecurityMode.None_);
  }

  static addIdentityType(builder: flatbuffers.Builder, identityType: Identity) {
    builder.addFieldInt8(5, identityType, Identity.NONE);
  }

  static addIdentity(builder: flatbuffers.Builder, identityOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, identityOffset, 0);
  }

  static addCertificate(builder: flatbuffers.Builder, certificateOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, certificateOffset, 0);
  }

  static addSession(builder: flatbuffers.Builder, sessionOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, sessionOffset, 0);
  }

  static addRedundancy(builder: flatbuffers.Builder, redundancyOffset: flatbuffers.Offset) {
    builder.addFieldOffset(9, redundancyOffset, 0);
  }

  static addSubscription(builder: flatbuffers.Builder, subscriptionOffset: flatbuffers.Offset) {
    builder.addFieldOffset(10, subscriptionOffset, 0);
  }

  static addNamedSubscriptions(
    builder: flatbuffers.Builder,
    namedSubscriptionsOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(11, namedSubscriptionsOffset, 0);
  }

  static createNamedSubscriptionsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startNamedSubscriptionsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addMonitors(builder: flatbuffers.Builder, monitorsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(12, monitorsOffset, 0);
  }

  static createMonitorsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startMonitorsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addMappings(builder: flatbuffers.Builder, mappingsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(13, mappingsOffset, 0);
  }

  static addNodeToLiftId(builder: flatbuffers.Builder, nodeToLiftIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(14, nodeToLiftIdOffset, 0);
  }

  static createNodeToLiftIdVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startNodeToLiftIdVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addMsgToMethod(builder: flatbuffers.Builder, msgToMethodOffset: flatbuffers.Offset) {
    builder.addFieldOffset(15, msgToMethodOffset, 0);
  }

  static createMsgToMethodVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startMsgToMethodVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addEventMonitors(builder: flatbuffers.Builder, eventMonitorsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(16, eventMonitorsOffset, 0);
  }

  static createEventMonitorsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startEventMonitorsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addEventToMsg(builder: flatbuffers.Builder, eventToMsgOffset: flatbuffers.Offset) {
    builder.addFieldOffset(17, eventToMsgOffset, 0);
  }

  static createEventToMsgVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startEventToMsgVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addHistoryReads(builder: flatbuffers.Builder, historyReadsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(18, historyReadsOffset, 0);
  }

  static createHistoryReadsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startHistoryReadsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addVendorPathLiteral(
    builder: flatbuffers.Builder,
    vendorPathLiteralOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(19, vendorPathLiteralOffset, 0);
  }

  static endMapping(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 16); // identity
    builder.requiredField(offset, 30); // mappings
    return offset;
  }

  static finishMappingBuffer(builder: flatbuffers.Builder, offset: flatbuffers.Offset) {
    builder.finish(offset);
  }

  static finishSizePrefixedMappingBuffer(builder: flatbuffers.Builder, offset: flatbuffers.Offset) {
    builder.finish(offset, undefined, true);
  }

  unpack(): MappingT {
    return new MappingT(
      this.applicationName(),
      this.applicationUri(),
      this.productUri(),
      this.securityPolicy(),
      this.securityMode(),
      this.identityType(),
      (() => {
        const temp = unionToIdentity(this.identityType(), this.identity.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
      this.certificate() !== null ? this.certificate()!.unpack() : null,
      this.session() !== null ? this.session()!.unpack() : null,
      this.redundancy() !== null ? this.redundancy()!.unpack() : null,
      this.subscription() !== null ? this.subscription()!.unpack() : null,
      this.bb!.createObjList<NamedSubscription, NamedSubscriptionT>(
        this.namedSubscriptions.bind(this),
        this.namedSubscriptionsLength(),
      ),
      this.bb!.createObjList<NodeMonitor, NodeMonitorT>(
        this.monitors.bind(this),
        this.monitorsLength(),
      ),
      this.mappings() !== null ? this.mappings()!.unpack() : null,
      this.bb!.createObjList<NodeToLiftIdEntry, NodeToLiftIdEntryT>(
        this.nodeToLiftId.bind(this),
        this.nodeToLiftIdLength(),
      ),
      this.bb!.createObjList<MessageToMethodEntry, MessageToMethodEntryT>(
        this.msgToMethod.bind(this),
        this.msgToMethodLength(),
      ),
      this.bb!.createObjList<EventMonitor, EventMonitorT>(
        this.eventMonitors.bind(this),
        this.eventMonitorsLength(),
      ),
      this.bb!.createObjList<EventToMessageEntry, EventToMessageEntryT>(
        this.eventToMsg.bind(this),
        this.eventToMsgLength(),
      ),
      this.bb!.createObjList<HistoryReadConfig, HistoryReadConfigT>(
        this.historyReads.bind(this),
        this.historyReadsLength(),
      ),
      this.vendorPathLiteral(),
    );
  }

  unpackTo(_o: MappingT): void {
    _o.applicationName = this.applicationName();
    _o.applicationUri = this.applicationUri();
    _o.productUri = this.productUri();
    _o.securityPolicy = this.securityPolicy();
    _o.securityMode = this.securityMode();
    _o.identityType = this.identityType();
    _o.identity = (() => {
      const temp = unionToIdentity(this.identityType(), this.identity.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
    _o.certificate = this.certificate() !== null ? this.certificate()!.unpack() : null;
    _o.session = this.session() !== null ? this.session()!.unpack() : null;
    _o.redundancy = this.redundancy() !== null ? this.redundancy()!.unpack() : null;
    _o.subscription = this.subscription() !== null ? this.subscription()!.unpack() : null;
    _o.namedSubscriptions = this.bb!.createObjList<NamedSubscription, NamedSubscriptionT>(
      this.namedSubscriptions.bind(this),
      this.namedSubscriptionsLength(),
    );
    _o.monitors = this.bb!.createObjList<NodeMonitor, NodeMonitorT>(
      this.monitors.bind(this),
      this.monitorsLength(),
    );
    _o.mappings = this.mappings() !== null ? this.mappings()!.unpack() : null;
    _o.nodeToLiftId = this.bb!.createObjList<NodeToLiftIdEntry, NodeToLiftIdEntryT>(
      this.nodeToLiftId.bind(this),
      this.nodeToLiftIdLength(),
    );
    _o.msgToMethod = this.bb!.createObjList<MessageToMethodEntry, MessageToMethodEntryT>(
      this.msgToMethod.bind(this),
      this.msgToMethodLength(),
    );
    _o.eventMonitors = this.bb!.createObjList<EventMonitor, EventMonitorT>(
      this.eventMonitors.bind(this),
      this.eventMonitorsLength(),
    );
    _o.eventToMsg = this.bb!.createObjList<EventToMessageEntry, EventToMessageEntryT>(
      this.eventToMsg.bind(this),
      this.eventToMsgLength(),
    );
    _o.historyReads = this.bb!.createObjList<HistoryReadConfig, HistoryReadConfigT>(
      this.historyReads.bind(this),
      this.historyReadsLength(),
    );
    _o.vendorPathLiteral = this.vendorPathLiteral();
  }

  unpackFields(...fields: string[]): MappingT {
    const t = new MappingT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("application_name")) {
      t.applicationName = this.applicationName();
    }
    if (fieldSet.has("application_uri")) {
      t.applicationUri = this.applicationUri();
    }
    if (fieldSet.has("product_uri")) {
      t.productUri = this.productUri();
    }
    if (fieldSet.has("security_policy")) {
      t.securityPolicy = this.securityPolicy();
    }
    if (fieldSet.has("security_mode")) {
      t.securityMode = this.securityMode();
    }
    if (fieldSet.has("identity_type")) {
      t.identityType = this.identityType();
    }
    if (fieldSet.has("identity")) {
      t.identity = (() => {
        const temp = unionToIdentity(this.identityType(), this.identity.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    if (fieldSet.has("certificate")) {
      t.certificate = this.certificate() !== null ? this.certificate()!.unpack() : null;
    }
    if (fieldSet.has("session")) {
      t.session = this.session() !== null ? this.session()!.unpack() : null;
    }
    if (fieldSet.has("redundancy")) {
      t.redundancy = this.redundancy() !== null ? this.redundancy()!.unpack() : null;
    }
    if (fieldSet.has("subscription")) {
      t.subscription = this.subscription() !== null ? this.subscription()!.unpack() : null;
    }
    if (fieldSet.has("named_subscriptions")) {
      t.namedSubscriptions = this.bb!.createObjList<NamedSubscription, NamedSubscriptionT>(
        this.namedSubscriptions.bind(this),
        this.namedSubscriptionsLength(),
      );
    }
    if (fieldSet.has("monitors")) {
      t.monitors = this.bb!.createObjList<NodeMonitor, NodeMonitorT>(
        this.monitors.bind(this),
        this.monitorsLength(),
      );
    }
    if (fieldSet.has("mappings")) {
      t.mappings = this.mappings() !== null ? this.mappings()!.unpack() : null;
    }
    if (fieldSet.has("node_to_lift_id")) {
      t.nodeToLiftId = this.bb!.createObjList<NodeToLiftIdEntry, NodeToLiftIdEntryT>(
        this.nodeToLiftId.bind(this),
        this.nodeToLiftIdLength(),
      );
    }
    if (fieldSet.has("msg_to_method")) {
      t.msgToMethod = this.bb!.createObjList<MessageToMethodEntry, MessageToMethodEntryT>(
        this.msgToMethod.bind(this),
        this.msgToMethodLength(),
      );
    }
    if (fieldSet.has("event_monitors")) {
      t.eventMonitors = this.bb!.createObjList<EventMonitor, EventMonitorT>(
        this.eventMonitors.bind(this),
        this.eventMonitorsLength(),
      );
    }
    if (fieldSet.has("event_to_msg")) {
      t.eventToMsg = this.bb!.createObjList<EventToMessageEntry, EventToMessageEntryT>(
        this.eventToMsg.bind(this),
        this.eventToMsgLength(),
      );
    }
    if (fieldSet.has("history_reads")) {
      t.historyReads = this.bb!.createObjList<HistoryReadConfig, HistoryReadConfigT>(
        this.historyReads.bind(this),
        this.historyReadsLength(),
      );
    }
    if (fieldSet.has("vendor_path_literal")) {
      t.vendorPathLiteral = this.vendorPathLiteral();
    }
    return t;
  }
}

export class MappingT implements flatbuffers.IGeneratedObject {
  constructor(
    public applicationName: string | Uint8Array | null = null,
    public applicationUri: string | Uint8Array | null = null,
    public productUri: string | Uint8Array | null = null,
    public securityPolicy: SecurityPolicy = SecurityPolicy.None_,
    public securityMode: MessageSecurityMode = MessageSecurityMode.None_,
    public identityType: Identity = Identity.NONE,
    public identity: AnonymousIdentityT | UserNameIdentityT | X509IdentityT | null = null,
    public certificate: CertificateConfigT | null = null,
    public session: SessionConfigT | null = null,
    public redundancy: RedundancyConfigT | null = null,
    public subscription: SubscriptionConfigT | null = null,
    public namedSubscriptions: NamedSubscriptionT[] = [],
    public monitors: NodeMonitorT[] = [],
    public mappings: OpcUaMappingsT | null = null,
    public nodeToLiftId: NodeToLiftIdEntryT[] = [],
    public msgToMethod: MessageToMethodEntryT[] = [],
    public eventMonitors: EventMonitorT[] = [],
    public eventToMsg: EventToMessageEntryT[] = [],
    public historyReads: HistoryReadConfigT[] = [],
    public vendorPathLiteral: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.identity === null || this.identity === undefined) {
      throw new Error('Required field "identity" is not set');
    }
    if (this.mappings === null || this.mappings === undefined) {
      throw new Error('Required field "mappings" is not set');
    }
    const applicationName =
      this.applicationName !== null ? builder.createString(this.applicationName!) : 0;
    const applicationUri =
      this.applicationUri !== null ? builder.createString(this.applicationUri!) : 0;
    const productUri = this.productUri !== null ? builder.createString(this.productUri!) : 0;
    const identity = builder.createObjectOffset(this.identity);
    const certificate = this.certificate !== null ? this.certificate!.pack(builder) : 0;
    const session = this.session !== null ? this.session!.pack(builder) : 0;
    const redundancy = this.redundancy !== null ? this.redundancy!.pack(builder) : 0;
    const subscription = this.subscription !== null ? this.subscription!.pack(builder) : 0;
    const namedSubscriptions = Mapping.createNamedSubscriptionsVector(
      builder,
      builder.createObjectOffsetList(this.namedSubscriptions),
    );
    const monitors = Mapping.createMonitorsVector(
      builder,
      builder.createObjectOffsetList(this.monitors),
    );
    const mappings = this.mappings !== null ? this.mappings!.pack(builder) : 0;
    const nodeToLiftId = Mapping.createNodeToLiftIdVector(
      builder,
      builder.createObjectOffsetList(this.nodeToLiftId),
    );
    const msgToMethod = Mapping.createMsgToMethodVector(
      builder,
      builder.createObjectOffsetList(this.msgToMethod),
    );
    const eventMonitors = Mapping.createEventMonitorsVector(
      builder,
      builder.createObjectOffsetList(this.eventMonitors),
    );
    const eventToMsg = Mapping.createEventToMsgVector(
      builder,
      builder.createObjectOffsetList(this.eventToMsg),
    );
    const historyReads = Mapping.createHistoryReadsVector(
      builder,
      builder.createObjectOffsetList(this.historyReads),
    );
    const vendorPathLiteral =
      this.vendorPathLiteral !== null ? builder.createString(this.vendorPathLiteral!) : 0;

    Mapping.startMapping(builder);
    Mapping.addApplicationName(builder, applicationName);
    Mapping.addApplicationUri(builder, applicationUri);
    Mapping.addProductUri(builder, productUri);
    Mapping.addSecurityPolicy(builder, this.securityPolicy);
    Mapping.addSecurityMode(builder, this.securityMode);
    Mapping.addIdentityType(builder, this.identityType);
    Mapping.addIdentity(builder, identity);
    Mapping.addCertificate(builder, certificate);
    Mapping.addSession(builder, session);
    Mapping.addRedundancy(builder, redundancy);
    Mapping.addSubscription(builder, subscription);
    Mapping.addNamedSubscriptions(builder, namedSubscriptions);
    Mapping.addMonitors(builder, monitors);
    Mapping.addMappings(builder, mappings);
    Mapping.addNodeToLiftId(builder, nodeToLiftId);
    Mapping.addMsgToMethod(builder, msgToMethod);
    Mapping.addEventMonitors(builder, eventMonitors);
    Mapping.addEventToMsg(builder, eventToMsg);
    Mapping.addHistoryReads(builder, historyReads);
    Mapping.addVendorPathLiteral(builder, vendorPathLiteral);

    return Mapping.endMapping(builder);
  }

  clone(): MappingT {
    const obj = new MappingT();
    obj.applicationName = this.applicationName;
    obj.applicationUri = this.applicationUri;
    obj.productUri = this.productUri;
    obj.securityPolicy = this.securityPolicy;
    obj.securityMode = this.securityMode;
    obj.identityType = this.identityType;
    obj.identity =
      this.identity !== null && typeof (this.identity as any).clone === "function"
        ? (this.identity as any).clone()
        : this.identity;
    obj.certificate = this.certificate !== null ? this.certificate!.clone() : null;
    obj.session = this.session !== null ? this.session!.clone() : null;
    obj.redundancy = this.redundancy !== null ? this.redundancy!.clone() : null;
    obj.subscription = this.subscription !== null ? this.subscription!.clone() : null;
    obj.namedSubscriptions = this.namedSubscriptions.map((e) => e.clone());
    obj.monitors = this.monitors.map((e) => e.clone());
    obj.mappings = this.mappings !== null ? this.mappings!.clone() : null;
    obj.nodeToLiftId = this.nodeToLiftId.map((e) => e.clone());
    obj.msgToMethod = this.msgToMethod.map((e) => e.clone());
    obj.eventMonitors = this.eventMonitors.map((e) => e.clone());
    obj.eventToMsg = this.eventToMsg.map((e) => e.clone());
    obj.historyReads = this.historyReads.map((e) => e.clone());
    obj.vendorPathLiteral = this.vendorPathLiteral;
    return obj;
  }

  equals(other: MappingT): boolean {
    if (this.applicationName !== other.applicationName) return false;
    if (this.applicationUri !== other.applicationUri) return false;
    if (this.productUri !== other.productUri) return false;
    if (this.securityPolicy !== other.securityPolicy) return false;
    if (this.securityMode !== other.securityMode) return false;
    if (this.identityType !== other.identityType) return false;
    if (this.identity !== null && other.identity !== null) {
      if (typeof (this.identity as any).equals === "function") {
        if (!(this.identity as any).equals(other.identity)) return false;
      } else if (this.identity !== other.identity) return false;
    } else if (this.identity !== other.identity) return false;
    if (this.certificate !== null && other.certificate !== null) {
      if (!this.certificate!.equals(other.certificate!)) return false;
    } else if (this.certificate !== other.certificate) return false;
    if (this.session !== null && other.session !== null) {
      if (!this.session!.equals(other.session!)) return false;
    } else if (this.session !== other.session) return false;
    if (this.redundancy !== null && other.redundancy !== null) {
      if (!this.redundancy!.equals(other.redundancy!)) return false;
    } else if (this.redundancy !== other.redundancy) return false;
    if (this.subscription !== null && other.subscription !== null) {
      if (!this.subscription!.equals(other.subscription!)) return false;
    } else if (this.subscription !== other.subscription) return false;
    if (this.namedSubscriptions.length !== other.namedSubscriptions.length) return false;
    for (let i = 0; i < this.namedSubscriptions.length; i++) {
      const a = this.namedSubscriptions[i];
      const b = other.namedSubscriptions[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.monitors.length !== other.monitors.length) return false;
    for (let i = 0; i < this.monitors.length; i++) {
      const a = this.monitors[i];
      const b = other.monitors[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.mappings !== null && other.mappings !== null) {
      if (!this.mappings!.equals(other.mappings!)) return false;
    } else if (this.mappings !== other.mappings) return false;
    if (this.nodeToLiftId.length !== other.nodeToLiftId.length) return false;
    for (let i = 0; i < this.nodeToLiftId.length; i++) {
      const a = this.nodeToLiftId[i];
      const b = other.nodeToLiftId[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.msgToMethod.length !== other.msgToMethod.length) return false;
    for (let i = 0; i < this.msgToMethod.length; i++) {
      const a = this.msgToMethod[i];
      const b = other.msgToMethod[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.eventMonitors.length !== other.eventMonitors.length) return false;
    for (let i = 0; i < this.eventMonitors.length; i++) {
      const a = this.eventMonitors[i];
      const b = other.eventMonitors[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.eventToMsg.length !== other.eventToMsg.length) return false;
    for (let i = 0; i < this.eventToMsg.length; i++) {
      const a = this.eventToMsg[i];
      const b = other.eventToMsg[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.historyReads.length !== other.historyReads.length) return false;
    for (let i = 0; i < this.historyReads.length; i++) {
      const a = this.historyReads[i];
      const b = other.historyReads[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.vendorPathLiteral !== other.vendorPathLiteral) return false;
    return true;
  }
}

export function verifyMapping(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 10, 1);
    verifier.checkScalarField(tablePos, 12, 1);
    verifier.checkScalarField(tablePos, 14, 1);
    verifier.checkUnionConsistency(tablePos, 14, 16, "identity");
    {
      const pos = verifier.checkOffsetField(tablePos, 16);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 14);
        switch (uType) {
          case 1: // AnonymousIdentity
            {
              const o = verifier.readInt32(pos);
              verifyAnonymousIdentity(verifier, pos + o);
            }
            break;
          case 2: // UserNameIdentity
            {
              const o = verifier.readInt32(pos);
              verifyUserNameIdentity(verifier, pos + o);
            }
            break;
          case 3: // X509Identity
            {
              const o = verifier.readInt32(pos);
              verifyX509Identity(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 16, "identity");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 18);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyCertificateConfig(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 20);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifySessionConfig(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 22);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyRedundancyConfig(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 24);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifySubscriptionConfig(verifier, fieldPos + tableOffset);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 26);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyNamedSubscription);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 28);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyNodeMonitor);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 30);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyOpcUaMappings(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 30, "mappings");
    {
      const pos = verifier.checkOffsetField(tablePos, 32);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyNodeToLiftIdEntry);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 34);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyMessageToMethodEntry);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 36);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyEventMonitor);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 38);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyEventToMessageEntry);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 40);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyHistoryReadConfig);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 42);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}

export function verifyRootAsMapping(buf: DataView, opts?: flatbuffers.VerifierOptions): void {
  const verifier = new flatbuffers.Verifier(buf, opts);
  const tablePos = verifier.readUint32(0);
  verifyMapping(verifier, tablePos);
}
